export class CONST {
    public static DAYINMILLIS = 86400000
    public static DEFAULT_SYNC_TIME = '0000-00-00 00:00:00'
    public static DEFAULT_MIGRATION_VERSION = '0.0.0'
}
